import { CarAttribute } from "./CarAttribute";
import { CarNavigationThumbs } from "./CarNavigationThumbs";
import React, { useEffect, useState } from "react";
import { Carousel } from "@mantine/carousel";
import { axiosInstance } from "../../Api/AxiosConfig";
import { SuggestedPriceCalculation } from "./SuggestedPriceCalculation";
import { ChevronRightIcon } from "@heroicons/react/24/solid";

export const CarDetailsMobile = ({ car, showPrice, showImageSection = false, open, close, selectedCarId }) => {
    const [showImageIndex, setShowImageIndex] = useState(0);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (open && (selectedCarId === car.hash)) {
            axiosInstance
                .get(car.info_endpoint)

                .then((response) => {
                    setData(response.data);
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, selectedCarId]);
    const handleThumbnailClick = (index) => {
        setShowImageIndex(index);
    }

    return (
        <>
            {data.length !== 0 &&
                <div>
                    <div className='flex mt-4 ml-6'>
                        <div>
                            <div onClick={close}>
                                <div className='border-b border-dashed h-[1px] mb-4 mt-4 mr-4'></div>
                                <div className='text-sm'>
                                    <CarAttribute label='VIN' value={data.cars.vin_no.value} />
                                    <CarAttribute label='Make' value={data.cars.make_name.value} />
                                    <CarAttribute label='Model' value={data.cars.model.value} />
                                    <CarAttribute label='Model year' value={data.cars.model_year.value} />
                                </div>
                                <div className='border-b border-dashed h-[1px] my-2 mr-4'></div>
                                <div className='text-sm'>
                                    <CarAttribute label='Car type' value={data.cars.car_type_name.value} />
                                    <CarAttribute label='Body type' value={data.cars.body_type_name.value} />
                                    <CarAttribute label='Seats' value={data.cars.seats.value} />
                                    <CarAttribute label='Service' value={data.cars.service.value} />
                                </div>
                                <div className='border-b border-dashed h-[1px] my-2 mr-4'></div>
                                <div className='text-sm'>
                                    <CarAttribute label='CO2 rating' value={data.cars.co2_rating_wltp.value} />
                                    <CarAttribute label='Gear' value={data.cars.gear_name.value} />
                                    {data.cars.fuel_name.value !== 'Electric' && <CarAttribute label='Engine size' value={data.cars.engine_size.value} />}
                                    <CarAttribute label='Damage' value={data.cars.damage_amount.value} />
                                </div>
                                <div className='border-b border-dashed h-[1px] my-2 mr-4'></div>
                            </div>

                            <div className="mt-4">
                                {data.documents.length > 0 &&
                                    <div className="mb-4">
                                        <div className="font-bold text-sm mb-1">Documents</div>
                                        <div className='flex-1 text-sm max-w-[250px] min-w-[250px]'>
                                            {data.documents.map((item) => (
                                                <div key={item.file_url} className="flex mb-1">
                                                    <div><img src="/images/pdf_new.png" alt="pdf document" className="w-6 mr-3" /></div>
                                                    <div><a href={item.file_url} target="_blank" className="underline" rel="noopener noreferrer">{item.cars_documents_types_name}</a></div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                }
                            </div>

                            {data.dkPrice.status &&
                                <div className='' style={{ display: showPrice && !car.is_sold ? 'block' : 'none' }}>
                                    {data.dkPrice.status &&
                                        <SuggestedPriceCalculation car={car} data={data} />
                                    }
                                </div>
                            }

                            {data.cars.condition.value !== null &&
                                <div className='mt-5'>
                                    <div className='text-base font-semibold mb-3'>Condition</div>
                                    <div className='max-w-[750px] whitespace-normal'>
                                        {data.cars.condition.value}
                                    </div>
                                </div>
                            }

                            {data.equipment.length > 0 &&
                                <div className='mt-5'>
                                    <div className='text-base font-semibold mb-3'>Equipment</div>
                                    <div className='whitespace-normal'>
                                        {data.equipment.map((item) => (
                                            <span key={item.name} className='mb-[10px] mr-2 px-2 py-1 rounded bg-gray-200 inline-block text-sm' style={{ lineHeight: '15px' }}>{item.name}</span>
                                        ))}
                                    </div>
                                </div>
                            }

                            {showImageSection &&
                                <>
                                    <div className='flex flex-wrap items-center my-4'>
                                        <CarNavigationThumbs images={data.images.all} maxImagesNumber={20} onClick={handleThumbnailClick} />
                                    </div>

                                    <div className="mt-4 mb-8" style={{ display: data.images.all.length > 0 ? 'block' : 'none' }}>
                                        <Carousel initialSlide={showImageIndex} classNames={{ control: 'text-white' }} nextControlIcon={<ChevronRightIcon />}>
                                            {data.images.all.map((image) => (
                                                <Carousel.Slide key={'large_image_' + image.file_url}>
                                                    <img id={'large_image_' + image.file_url} src={image.file_url} className='rounded object-cover w-full' alt='Car' />
                                                </Carousel.Slide>
                                            ))}
                                        </Carousel>
                                    </div>
                                </>
                            }
                        </div>
                    </div>

                </div>
            }
        </>
    )
}